<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Wallet Connect</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Wallet Accounts</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="connectToWallet" class="btn add-btn" href="javascript:void(0)">
                  <i class="la la-cloud"></i> Connect Account
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <template>
                  <div class="col-md-12 col-lg-4 col-xl-4 d-flex">
                    <div class="leave-info-box card flex-fill">
                      <div class="row align-items-center mt-3">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-3 text-center">
                              <a href="javascript:void(0)" class="squared">
                                <img style="width:100%" alt src="@/assets/wallets/eth.png" />
                              </a>
                            </div>
                            <div class="col-9">
                              <h4>
                                ETH
                              </h4>
                              <span class="text-sm text-muted">Address: xx</span>
                            </div>
                          </div>
                          <div class="text-left">
                            <div class="media-body"></div>
                          </div>
                          <table class="table table-striped">
                            <tr>
                              <td style="width:40%;">Balance</td>
                              <td>10 ETH</td>
                            </tr>
                          </table>
                          <div class="text-right text-muted">
                            <small>Last Updated: </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";


import { formatLocalDate, timeAgo } from "@/utils/helper";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
// import { providers } from "ethers";
// import { provider } from "@/utils/walletConnect";

// import WalletConnectProvider from "@walletconnect/web3-provider";
// export const provider = new WalletConnectProvider({
//   infuraId: "91c940fc7577497487d3b841d44e3a84",
// });

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
  },
  data() {
    return {
      loading: false,
    };
    //  isactive : true
  },

  created() {
  },
  methods: {
    async connectToWallet() {
      // try {
      //   const { state } = connect();
      //   //  Enable session (triggers QR Code modal)
      //   await provider.enable();
      //   const web3Provider = new providers.Web3Provider(provider);
      //   const signer = await web3Provider.getSigner();
      //   const address = await signer.getAddress();
      //   state.status = true;
      //   state.address = address;
      //   state.chainId = await provider.request({ method: "eth_chainId" });

      //   provider.on("disconnect", (code, reason) => {
      //     console.log(code, reason);
      //     console.log("disconnected");
      //     state.status = false;
      //     state.address = "";
      //     localStorage.removeItem("userState");
      //   });

      //   provider.on("accountsChanged", (accounts) => {
      //     if (accounts.length > 0) {
      //       state.address = accounts[0];
      //     }
      //   });

      //   provider.on("chainChanged", (chainId) => {
      //     state.chainId = chainId
      //   });
      // } catch (error) {
      //   console.log(error);
      // }
    }
  },
  mounted() {
  },
  name: "wallconn-list"
};
</script>


// WEBPACK FOOTER //
// src/views/walletconnect/list.vue